import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  RESET_LOGIN_FLAG,
  RENEW_TOKEN,
  RENEW_TOKEN_SUCCESS,
  RENEW_TOKEN_ERROR,
  USER_ONLINE_STATUS,
  USER_ONLINE_STATUS_SUCCESS,
  USER_ONLINE_STATUS_ERROR,
} from "./actionTypes";

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  };
};

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const logoutUser = (history) => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  };
};

export const resetLoginFlag = () => {
  return {
    type: RESET_LOGIN_FLAG,
  };
};

export const renewToken = () => {
  return {
    type: RENEW_TOKEN,
  };
};

export const renewTokenSuccess = (tokenRenew) => {
  return {
    type: RENEW_TOKEN_SUCCESS,
    payload: tokenRenew,
  };
};

export const renewTokenError = (error) => {
  return {
    type: RENEW_TOKEN_ERROR,
    payload: error,
  };
};

export const userOnlineStatus = (user) => {
  return {
    type: USER_ONLINE_STATUS,
    payload: user,
  };
};

export const userOnlineStatusSuccess = (user) => {
  return {
    type: USER_ONLINE_STATUS_SUCCESS,
    payload: user,
  };
};

export const userOnlineStatusError = (error) => {
  return {
    type: USER_ONLINE_STATUS_ERROR,
    payload: error,
  };
};
